$(function() {
    $.each($('[layout-content]'), function() {
        if ($(this).attr('layout-content') !== 'hero') { // Check if layout-content is not 'hero'
            let $p = $(this).children().last();
            if ($p.is('p')) {
                $p.addClass('mb-0');
            }
        }
    });
});